"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bracciano": {
    "afaae098": [{
      "hkey": "4066ba12",
      "slug": "bracciano-2",
      "name": "Bracciano 2",
      "primary": true,
      "skipSearch": false
    }],
    "campo-della-fiera": [{
      "hkey": "4066ba12",
      "slug": "bracciano-2",
      "name": "Bracciano 2",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7509a0d6": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "skipSearch": false
    }],
    "cartiere": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d6f91c22": [{
      "hkey": "1e54a478",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "1e54a478",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "119150ed": [{
      "hkey": "4066ba12",
      "slug": "bracciano-2",
      "name": "Bracciano 2",
      "primary": true,
      "skipSearch": false
    }],
    "cinquilla": [{
      "hkey": "4066ba12",
      "slug": "bracciano-2",
      "name": "Bracciano 2",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2b87c521": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "skipSearch": false
    }],
    "circumlacuale": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0d1d113": [{
      "hkey": "1e54a478",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "don-cesolini": [{
      "hkey": "1e54a478",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0c369ec6": [{
      "hkey": "ddb289f1",
      "slug": "monte-franco-rinascente",
      "name": "Monte Franco-Rinascente",
      "primary": true,
      "skipSearch": false
    }],
    "monte-franco": [{
      "hkey": "ddb289f1",
      "slug": "monte-franco-rinascente",
      "name": "Monte Franco-Rinascente",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e640ad83": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "skipSearch": false
    }],
    "monti": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5e1662e": [{
      "hkey": "ddb289f1",
      "slug": "monte-franco-rinascente",
      "name": "Monte Franco-Rinascente",
      "primary": true,
      "skipSearch": false
    }],
    "rinascente": [{
      "hkey": "ddb289f1",
      "slug": "monte-franco-rinascente",
      "name": "Monte Franco-Rinascente",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "315350d7": [{
      "hkey": "a7ef7c61",
      "slug": "quarto-del-lago-santo-celso-sassone",
      "name": "Quarto del Lago-Santo Celso-Sassone",
      "primary": true,
      "skipSearch": false
    }],
    "santo-celso": [{
      "hkey": "a7ef7c61",
      "slug": "quarto-del-lago-santo-celso-sassone",
      "name": "Quarto del Lago-Santo Celso-Sassone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "28f85731": [{
      "hkey": "1e54a478",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "1e54a478",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "59de872a": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "skipSearch": false
    }],
    "vicarello": [{
      "hkey": "175094aa",
      "slug": "bracciano",
      "name": "Bracciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;